import { Backdrop, Container, Input, Paper, Snackbar } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import SearchIcon from '@material-ui/icons/Search';
import Alert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/styles';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { getTasksRequest } from '../../store/actions/taskActions';
import BulletinDetail from './BulletinDetail';

const useStyles = makeStyles(theme => ({
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0)'
  },
  root: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  cardscontent: {
    minHeight: 300
  },
  BultenDetay: {
    marginTop: theme.spacing(1)
  },
  searchB: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconB: {
    marginRight: theme.spacing(0),
    color: theme.palette.icon
  },
  searchInputB: {
    flexGrow: 1
  },
  searchButtonB: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  }
}));

const Bulten = props => {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [BultenData, setBultenData] = useState([]);
  const SessionUser = getUser();
  const [Loading, setLoading] = useState(false);
  const [filter, setFilter] = useState('0');
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const SearchStr = sessionStorage.getItem('SearhContentSearchParam');
  var TitleApp = "Sirius CRM";
  if (SessionUser.Role === 2) {
    TitleApp = "Sirius Partner"
  }
  const BultenIcerikAra = () => {
    setLoading(true);
    setBultenData([]);
    axios
      .get(
        `/GetSiriusBulletin/2/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}/${filter}`
      )
      .then(response => {
        const Deger = response.data;
        if (Deger.length > 0) {
          setBultenData(Deger);
        } else {
          setOpenSnackbar(true);
          setBultenData([]);
        }

        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  };
  const BultenIcerikAraGlobal = Param => {
    setLoading(true);
    setBultenData([]);
    axios
      .get(
        `/GetSiriusBulletin/2/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}/${Param}`
      )
      .then(response => {
        const Deger = response.data;
        if (Deger.length > 0) {
          setBultenData(Deger);
        } else {
          setOpenSnackbar(true);
          setBultenData([]);
        }

        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  };
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };
  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      BultenIcerikAra();
    }
  };

  useEffect(() => {
    if (SearchStr?.length > 3) {
      setFilter(SearchStr);
      BultenIcerikAraGlobal(SearchStr);
      sessionStorage.removeItem('SearhContentSearchParam');
    }
  }, [SearchStr]);

  return (
    <Page className={classes.root} title={TitleApp}>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        <Alert onClose={handleSnackbarClose} severity="error">
          {t('lblNotSearchContent')}
        </Alert>
      </Snackbar>
      <Backdrop className={classes.backdrop} open={Loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container maxWidth="xl">
        <Paper className={classes.searchB} elevation={1}>
          <Input
            className={classes.searchInputB}
            disableUnderline
            onKeyDown={handleKeyDown}
            onChange={event => {
              setFilter(event.target.value);
            }}
            placeholder={t('lblSearchContent')}
          />
          <SearchIcon
            onClick={BultenIcerikAra}
            className={classes.searchIconB}
          />
        </Paper>
        <BulletinDetail
          className={classes.BultenDetay}
          BultenData={BultenData}
          loading={Loading}
          setLoading={setLoading}
        />
      </Container>
    </Page>
  );
};

export default connect(state => ({ tasks: state.tasks1 }), {
  getTasksRequest
})(Bulten);
